import type { ReactNode } from 'react';
import React, { Children } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { isEmpty } from 'lodash';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import type { TrackingPayload } from 'Tracking/tracking-api/useTracking';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import Image from 'Components/frameworks/image/Image';
export type MediaThumbnailProps = {
  alt?: string;
  children?: ReactNode;
  className?: string;
  hasLazyLoading?: boolean;
  iconName?: IconName;
  onClick?: () => void;
  ratio?: string;
  src: string;
  trackingData?: TrackingPayload;
  ratioDisplay?: number;
};
export const MediaThumbnail = ({
  alt,
  children,
  className,
  hasLazyLoading,
  iconName,
  onClick,
  ratio = ratioUtils.M,
  src,
  trackingData,
  ratioDisplay,
}: MediaThumbnailProps) => {
  const hasChildren = !!Children.count(children);
  const track = useTracking(trackingData);

  if (!hasChildren && isEmpty(src)) {
    return null;
  }

  return (
    <button
      className={classnames(
        'relative block h-full w-full overflow-hidden bg-white transition-opacity duration-250 ease-in hover:opacity-75',
        className,
      )}
      onClick={() => {
        onClick?.();
        trackingData && track();
      }}
      type="button"
    >
      {hasChildren ? (
        children
      ) : (
        <Image
          altMsg={alt}
          hasLazyLoading={hasLazyLoading}
          imageUrl={src}
          ratioKey={ratio}
          ratioDisplay={ratioDisplay}
        />
      )}
      {!!iconName && (
        <div className="absolute end-0 top-0 m-5 size-50 bg-black/60 p-10 leading-0 text-white">
          <Icon name={iconName} width="100%" />
        </div>
      )}
    </button>
  );
};
